import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TW2424Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TW2424IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4V19H22V4H2Z"
        fill="#EF0000"
      />
      <mask
        id="mask0_1813_897"
        mask-type="luminance"
        maskUnits="userSpaceOnUse"
        x="2"
        y="4"
        width="20"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4V19H22V4H2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1813_897)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4V12.75H13.25V4H2Z"
          fill="#2E42A5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.45602 10.7567L6.52998 11.912L6.30567 10.4485L4.92604 10.986L5.46355 9.60637L4 9.38206L5.15532 8.45602L4 7.52998L5.46355 7.30567L4.92604 5.92604L6.30567 6.46355L6.52998 5L7.45602 6.15532L8.38206 5L8.60637 6.46355L9.986 5.92604L9.44848 7.30567L10.912 7.52998L9.75672 8.45602L10.912 9.38206L9.44848 9.60637L9.986 10.986L8.60637 10.4485L8.38206 11.912L7.45602 10.7567ZM7.45579 10.245C8.44381 10.245 9.24476 9.44401 9.24476 8.45599C9.24476 7.46797 8.44381 6.66703 7.45579 6.66703C6.46777 6.66703 5.66682 7.46797 5.66682 8.45599C5.66682 9.44401 6.46777 10.245 7.45579 10.245ZM8.88676 8.45608C8.88676 9.24649 8.246 9.88725 7.45559 9.88725C6.66517 9.88725 6.02441 9.24649 6.02441 8.45608C6.02441 7.66566 6.66517 7.0249 7.45559 7.0249C8.246 7.0249 8.88676 7.66566 8.88676 8.45608Z"
          fill="#FEFFFF"
        />
      </g>
    </svg>
  );
};

export default TW2424Icon;
